<template>
  <div class="mod__login-container">
    <div class="logo">
      <img src="~assets/logo-big.png" alt="logo" />
    </div>
    <div class="login-main">
      <div class="slogan">
        <h2 class="slogan-title">
          {{ $t('login.slogan-title') }}
        </h2>
        <p class="slogan-content">
          {{ $t('login.slogan-content') }}
        </p>
      </div>
      <div class="panel">
        <Panel />
      </div>
    </div>
    <div v-if="envSwitchable" class="env-switch">
      <select
        class="env-switch-select"
        :value="currentEnv"
        @change="changeEnv($event.target.value)"
      >
        <option value="test">
          测试环境
        </option>
        <option value="production">
          线上环境
        </option>
      </select>
    </div>
    <div class="copyright">
      ©2019-{{ year }} TradeUP Inc.All rights reserved
    </div>
  </div>
</template>

<script>
import Panel from './Panel'
import getEnv, { isEnvSwitchable, setEnv } from 'utils/getEnv'
export default {
  name: 'Login',

  components: {
    Panel
  },
  data() {
    return {
      envSwitchable: isEnvSwitchable(),
      currentEnv: getEnv()
    }
  },
  computed: {
    year() {
      const gap = this.$store.state.timegap.localServerTimeGap
      return new Date(new Date().getTime() - gap).getFullYear()
    }
  },
  methods: {
    changeEnv(env) {
      if (env === this.currentEnv) return
      setEnv(env)
      window.location.reload()
    }
  }
}
</script>

<style lang="less" type="text/less">
@import '~uikit';
.mod__login-container {
  background: var(--bg-block);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('~assets/login-background.png') no-repeat center;
  background-size: cover;
  .login-main {
    position: relative;
    display: flex;
    .panel {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 340px;
      border-radius: 8px;
      min-height: 100px;
      background: #ffffff;
      box-shadow: 0 10px 20px 0 rgba(35, 44, 55, 0.05);
    }
    .slogan {
      max-width: 640px;
      margin-right: 46px;
      letter-spacing: 1px;
      .slogan-title {
        font-weight: bold;
        font-size: 42px;
        line-height: 1;
        letter-spacing: 1px;
        margin: 48px 0 30px;
        white-space: nowrap;
        color: @white;
      }
      .slogan-content {
        margin: 0;
        font-size: 24px;
        letter-spacing: 1px;
        color: @white;
      }
    }
  }
  .logo {
    position: absolute;
    top: 31px;
    left: 280px;
    img {
      display: block;
      width: 164px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .copyright {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 20px;
    letter-spacing: 1px;
    color: @white;
    text-align: center;
  }
  .env-switch {
    position: absolute;
    top: 28px;
    left: 32px;
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 12px;
      margin-top: -2px;
      border-top: 5px solid @white;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      pointer-events: none;
    }
    .env-switch-select {
      height: 30px;
      padding: 0 30px 0 12px;
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 15px;
      background: rgba(0, 0, 0, 0.25);
      color: @white;
      font-size: 13px;
      line-height: 28px;
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      outline: none;
      option {
        color: #2a323f;
        background: #fff;
      }
    }
  }
  @media (max-width: 768px) {
    .env-switch {
      top: 16px;
      left: 16px;
    }
  }
  @media (max-width: 768px) {
    .login-main {
      display: block;
      .slogan {
        margin-right: 0;
      }
      .panel {
        margin: 60px auto 0;
      }
    }
  }
}
</style>
